import React from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { StyledEngineProvider } from "@mui/material";
import { MeshGradient, NavigationBar } from "../../components";
import { LoginContainer, LoginOrRegisterContainer } from "./Login.styles";
import { LoginForm } from "../../components/Login";

interface LoginProps extends WithRouterProps {
}

const Login: React.FC<LoginProps> = ({
    router,
    ...rest
}) => {
    const { query } = router;
    const redirectURLParam = query.redirectUrl;
    const redirectURL = typeof redirectURLParam === 'string' ? redirectURLParam : '';
 
    return (
        <StyledEngineProvider injectFirst>
            <NavigationBar showMenu={true} showLoginButton={false} />
            <LoginContainer>
                <LoginOrRegisterContainer>
                    <LoginForm redirectURL={redirectURL} {...rest} />
                </LoginOrRegisterContainer>
                <MeshGradient sx={{ position: 'fixed' }} colour={"teal-green"} position="bottom" size="low" />
            </LoginContainer>
        </StyledEngineProvider>
    );
};

export default withRouter(Login);
